import "core-js/modules/es.array.push.js";
import { message, Modal } from 'ant-design-vue';
import { ExclamationCircleOutlined, SoundFilled } from '@ant-design/icons-vue';
import { getCurrentInstance, inject, createVNode } from 'vue';
import axios from '../store/interface';
import { lang } from '@/locales';
import { setItemToCookie } from '../utils/url-tools';
// import axios from 'axios'
// import reqwest from 'reqwest'

export default {
  name: 'index',
  data() {
    return {
      account: '',
      password: '',
      auth_uid: '',
      accountList: [],
      isOnlyOneLogin: true,
      activeKey: this.$route.params && this.$route.params.type ? this.$route.params.type : '1',
      privateDeploy: process.env.VUE_APP_PRIVATE_CUSTOM === '1',
      verCode: ''
    };
  },
  components: {
    SoundFilled
  },
  created() {
    localStorage.removeItem('token');
    localStorage.removeItem('ocrPersonInfo');
    // console.log(process.env.VUE_APP_BASE_URL)
  },
  mounted() {
    const _this = this;
    document.onkeydown = function (e) {
      // 按下回车提交
      const key = window.event.keyCode;
      // 事件中keycode=13为回车事件
      if (key == 13 && _this.isOnlyOneLogin) {
        _this.goTo();
      }
    };
  },
  methods: {
    goTo: function (event) {
      if (!this.account) {
        message.warning(lang('ph_phone_email1'));
        return false;
      }
      if (!this.password) {
        message.warning(lang('ph_pass'));
        return false;
      }
      if (this.accountList.length > 0) {
        if (!this.auth_uid) {
          message.warning(lang('ph_auth_uid'));
          return false;
        }
      }
      // 登录时清空搜索条件
      this.$store.dispatch('select/setProject', {});
      this.$store.dispatch('select/setCategory', {});
      this.fetch({
        account: this.account,
        password: this.password,
        role: this.activeKey,
        auth_uid: this.auth_uid ? this.auth_uid : ''
      });
    },
    goToRegister() {
      this.$router.push('/register/' + this.activeKey);
    },
    goToFind() {
      this.$router.push('/find');
    },
    showConfirm(_this, msg) {
      Modal.confirm({
        title: msg,
        icon: createVNode(ExclamationCircleOutlined),
        content: lang('tip_kick'),
        okText: lang('continue_login'),
        okType: 'danger',
        cancelText: lang('cancel'),
        onOk() {
          _this.fetch({
            account: _this.account,
            password: _this.password,
            auth_uid: _this.auth_uid ? _this.auth_uid : '',
            role: _this.activeKey,
            confirm: 1
          });
        },
        onCancel() {
          console.log('Cancel');
        }
      });
    },
    fetch(params = {}) {
      // console.log(localStorage.ocrPersonInfo)
      if (localStorage.ocrPersonInfo) {
        console.log('已登录');
        return;
      }
      const _this = this;
      if (this.activeKey === '4') {
        params.verification_code = this.verCode;
      }
      const promise = new Promise((resolve, reject) => {
        axios({
          method: 'post',
          url: process.env.VUE_APP_BASE_URL + 'manage/auth/login',
          data: {
            ...params
          }
        }).then(function (data) {
          resolve(data.data);
        });
      });
      promise.then(result => {
        if (result.code == 200) {
          const res = result.data;
          // 清空筛选
          this.$store.dispatch('select/clearSelect');
          if (res.accountList && res.accountList.length > 0) {
            _this.accountList = res.accountList;
          } else {
            if (result.errCode == 'LOGIN_REPEAT') {
              _this.isOnlyOneLogin = false;
              _this.showConfirm(_this, result.message);
            } else {
              setItemToCookie('dots-token', res.token, null, '/', '', null);
              localStorage.token = res.token;
              localStorage.ocrPersonInfo = JSON.stringify(res.info);
              if (res.info.role == '40') {
                _this.$router.push('/tag');
              } else if (res.info.role == '30') {
                _this.$router.push('/supplier');
              } else if (res.info.role == '50') {
                _this.$router.push('/checkout');
              } else {
                _this.$router.push('/home');
              }
            }
          }
        }
      });

      // reqwest({
      //   // 本地测试登录环境 上线记得还原
      //   // url: 'http://182.92.224.47:3000/manage/auth/login',
      //   url: process.env.VUE_APP_BASE_URL + 'manage/auth/login',
      //   method: 'post',
      //   crossOrigin: true,
      //   data: {
      //     ...params
      //   }
      // }).then(data => {
      //   if (data.code == 200) {
      //     const result = data.data
      //     if (result.accountList && result.accountList.length > 0) {
      //       _this.accountList = result.accountList
      //     } else {
      //       if (data.errCode == 'LOGIN_REPEAT') {
      //         _this.isOnlyOneLogin = false
      //         _this.showConfirm(_this, data.message)
      //       } else {
      //         localStorage.token = result.token
      //         localStorage.ocrPersonInfo = JSON.stringify(result.info)
      //         if (result.info.role == '40') {
      //           _this.$router.push('/tag')
      //         } else if(result.info.role == '30') {
      //           _this.$router.push('/supplier')
      //         } else if(result.info.role == '50') {
      //           _this.$router.push('/checkout')
      //         } else {
      //           _this.$router.push('/home')
      //         }
      //       }
      //     }
      //   } else {
      //     message.error(data.message)
      //   }
      // })

      // axios({
      //   method: 'post',
      //   url: process.env.VUE_APP_BASE_URL + 'manage/auth/login',
      //   data: {
      //     ...params
      //   }
      // }).then(function (data) {
      //   if (data.data.code == 200) {
      //     let result=data.data.data
      //     if(result.accountList&&result.accountList.length>0){
      //       _this.accountList=result.accountList
      //     }else{
      //       if(data.data.errCode=='LOGIN_REPEAT'){
      //         console.log(12);
      //         _this.showConfirm(_this,data.data.message);
      //       }else{
      //         localStorage.token = result.token
      //         localStorage.ocrPersonInfo = JSON.stringify(result.info)
      //         if (result.info.role == '40') {
      //           window.location.href =
      //             process.env.VUE_APP_Front_URL + '?token=' + localStorage.token
      //         } else {
      //           _this.$router.push('project')
      //         }
      //       }
      //     }
      //   }else {
      //     message.error(data.data.message)
      //   }
      // }).catch(function (error) {
      //   console.log(error);
      // });
    }
  },
  props: {
    msg: String
  }
};